module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 122
// module chunks = 0